import { useMemo } from 'react';
import MetricCard from '../shared/MetricCard';
import Badge from '../shared/Badge';
import DataTable from '../shared/DataTable';
import EmptyState from '../shared/EmptyState';
import { formatMoney, formatDate } from '../../utils/formatters';

export default function ReceivedNotOnTicket({ data }) {
  const items = data?.items || [];
  const totalCost = data?.total_cost_usd || 0;
  const unpaidCount = data?.unpaid_count || 0;
  const unpaidTotal = data?.unpaid_total_usd || 0;

  const columns = useMemo(() => [
    {
      key: 'part_name',
      label: 'Part',
      render: (row) => (
        <div>
          <div className="font-bold text-sm">{row.part_name}</div>
          <div className="text-xs text-gray-400">{row.part_number}</div>
        </div>
      ),
    },
    {
      key: 'vendor_name',
      label: 'Vendor',
      render: (row) => <span className="text-sm">{row.vendor_name}</span>,
    },
    {
      key: 'po_number',
      label: 'PO #',
      render: (row) => <span className="font-mono text-xs">#{row.po_number}</span>,
    },
    {
      key: 'received_date',
      label: 'Received',
      render: (row) => <span className="text-xs">{formatDate(row.received_date)}</span>,
    },
    {
      key: 'cost_usd',
      label: 'Cost',
      align: 'right',
      render: (row) => <span className="font-bold">{formatMoney(row.cost_usd)}</span>,
    },
    {
      key: 'payment_status',
      label: 'Payment',
      render: (row) => {
        const isPaid = row.payment_status === 'PAID';
        return <Badge severity={isPaid ? 'ok' : 'warning'} text={row.payment_status || 'UNPAID'} />;
      },
    },
  ], []);

  return (
    <div>
      <div className="flex gap-3 mb-6 flex-wrap">
        <MetricCard
          label="Parts Not on Ticket"
          value={items.length.toString()}
          accent="#14B8A6"
          icon={'\uD83D\uDCE5'}
        />
        <MetricCard
          label="Total Cost"
          value={formatMoney(totalCost)}
          accent="#C62828"
        />
        <MetricCard
          label="Unpaid"
          value={`${unpaidCount} (${formatMoney(unpaidTotal)})`}
          sub="Not yet paid to vendor"
          accent="#E65100"
        />
      </div>

      <div className="text-xs text-gray-500 mb-4 px-3 py-2 bg-teal-50 rounded-lg border border-teal-200">
        Parts received on a purchase order but never added to any repair order. These represent inventory costs without associated revenue.
      </div>

      {items.length > 0 ? (
        <DataTable columns={columns} data={items} />
      ) : (
        <EmptyState text="All received parts are on tickets" />
      )}
    </div>
  );
}
